import { Component, ChangeDetectionStrategy } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomTokenProviderComponent {}
